import React from 'react';
import { X } from 'lucide-react';
interface SalesConditionsModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export function SalesConditionsModal({
  isOpen,
  onClose
}: SalesConditionsModalProps) {
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-[100] flex items-center justify-center p-4" data-id="element-235">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={onClose} data-id="element-236"></div>

      {/* Modal */}
      <div className="relative bg-white rounded-3xl shadow-2xl max-w-4xl w-full max-h-[85vh] flex flex-col z-10" data-id="element-237">
        {/* Header */}
        <div className="flex items-center justify-between p-6 md:p-8 border-b border-gray-100 flex-shrink-0" data-id="element-238">
          <h2 className="text-2xl font-bold text-gray-900" data-id="element-239">
            Condiciones Generales de Venta
          </h2>
          <button onClick={onClose} className="w-10 h-10 rounded-full bg-gray-100 flex items-center justify-center hover:bg-gray-200 transition-colors flex-shrink-0" data-id="element-240">
            <X className="w-5 h-5 text-gray-600" data-id="element-241" />
          </button>
        </div>

        {/* Content */}
        <div className="overflow-y-auto p-6 md:p-8 space-y-6 text-gray-700 leading-relaxed" data-id="element-242">
          <p data-id="element-243">
            Las plataformas de ZUMPAGO permiten a sus usuarios adquirir y/o
            contratar diversos productos y servicios de manera confiable, segura
            y cómoda. A efectos de proporcionar a nuestros usuarios un servicio
            integral en los procesos de adquisición y/o contratación a través de
            este sitio web, los usuarios deberán adherirse y aceptar
            completamente los términos y condiciones establecidos en las
            presentes Condiciones Generales de Venta. Todo usuario que no esté
            de acuerdo en todo o en parte con lo estipulado en estas Condiciones
            Generales, deberá de abstenerse de adquirir y/o contratar los
            productos y servicios ofrecidos a través de nuestras plataformas.
            Dada la importancia de lo anterior, se resalta el hecho de que la
            adquisición y/o contratación de productos o servicios a través de
            nuestras plataformas, implica la aceptación de las presentes
            condiciones generales de venta.
          </p>

          <h3 className="text-xl font-bold text-gray-900 pt-2" data-id="element-244">
            1. DEFINICIONES
          </h3>
          <p data-id="element-245">
            <strong data-id="element-246">Plataformas.</strong> Se considera a los Sitios Web
            disponibles que incluye los dominios www.zumpago.com,
            www.zumpago.com.ar, www.zumpago.cl, www.zumpago.ec y www.zumpago.pe
            y a las APPs disponibles en las tiendas Google Play y App Store.
          </p>
          <p data-id="element-247">
            <strong data-id="element-248">Producto disponible.</strong> De forma individual, hará
            referencia a todo tipo de bien, así como todo tipo de servicio
            independientemente de su naturaleza que se encuentre disponible en
            el sitio web para su compra, adquisición o contratación, aun de
            manera gratuita. Cuando se haga referencia a más de un producto
            disponible se hará referencia a estos como "productos disponibles".
          </p>
          <p data-id="element-249">
            <strong data-id="element-250">Producto adquirido.</strong> Todo tipo de bien, así como
            todo tipo de servicio independientemente de su naturaleza, una vez
            que haya sido comprado o contratado por cualquier usuario del sitio
            web o APP. Cuando se haga referencia a más de un producto adquirido
            se hará referencia a estos como "productos adquiridos".
          </p>
          <p data-id="element-251">
            <strong data-id="element-252">Usuario.</strong> Toda persona independiente de su
            naturaleza que haga uso del sitio web o APP, especialmente si esta
            compra o adquiere, pretende comprar o adquirir, contrata, o pretende
            contratar los productos disponibles a través de una plataforma.
          </p>
          <p data-id="element-253">
            <strong data-id="element-254">Titular.</strong> El dueño o titular del sitio web y APP,
            que para todos los efectos legales es ZUMPAGO, será la única entidad
            que comercialice los productos disponibles en las plataformas y
            podrá ser contactado a través de los siguientes medios de contacto:
          </p>
          <p data-id="element-255">
            Correo:{' '}
            <a href="mailto:contacto@zumpago.com" className="text-zumpago-red hover:underline" data-id="element-256">
              contacto@zumpago.com
            </a>
          </p>
          <p data-id="element-257">
            <strong data-id="element-258">Orden de pago.</strong> Documento generado en la plataforma
            que contendrá el conjunto de productos adquiridos por el usuario, y
            que ZUMPAGO se compromete a entregar y/o llevar a cabo.
          </p>
          <p data-id="element-259">
            <strong data-id="element-260">Razones Sociales.</strong> Se refiere a los nombres legales
            de ZUMPAGO en cada país. Se entiende como ZUMPAGO a la marca
            comercial, siendo las razones sociales definidas por país.
          </p>

          <h3 className="text-xl font-bold text-gray-900 pt-2" data-id="element-261">
            2. DEL USUARIO
          </h3>
          <p data-id="element-262">
            Para todos los efectos legales, se considerará que el usuario es una
            persona o representante legal de una entidad con capacidad legal
            para contratar y obligarse en los términos del presente documento,
            en este sentido, todo usuario de las plataformas tiene la obligación
            de utilizarlas de manera responsable y correcta, por lo cual el
            usuario se compromete a:
          </p>
          <p data-id="element-263">
            <strong data-id="element-264">2.1.-</strong> Comprar, adquirir o contratar los productos o
            servicios disponibles de forma legal y en caso de que el usuario
            tenga conocimiento de cualquier circunstancia que pudiera afectar
            jurídicamente la actividad que se desarrolla a través de la
            plataforma, lo hará del conocimiento a ZUMPAGO de forma inmediata.
          </p>
          <p data-id="element-265">
            <strong data-id="element-266">2.2.-</strong> No realizar ninguna compra o adquisición de
            manera simulada o fraudulenta. En caso de que se compruebe que el
            usuario ha realizado alguna actividad de este tipo, esta podrá ser
            cancelada y se dará aviso a las autoridades correspondientes.
          </p>
          <p data-id="element-267">
            <strong data-id="element-268">2.3.-</strong> Proporcionar información veraz, cuando la
            misma sea requerida para contratar, adquirir o comprar los productos
            o servicios disponibles.
          </p>
          <p data-id="element-269">
            <strong data-id="element-270">2.4.-</strong> Asimismo, se informa que las presentes
            condiciones podrán ser modificadas en cualquier momento, por lo
            cual, el usuario es responsable de consultar las actualizaciones que
            se realicen al presente documento, no obstante, en el caso de que el
            usuario compre, adquiera o contrate alguno de los productos
            disponibles en las plataformas, le serán aplicables aquellas que se
            encuentren publicadas en el momento en que se solicite la
            adquisición o compra.
          </p>

          <h3 className="text-xl font-bold text-gray-900 pt-2" data-id="element-271">
            3. PROCESO DE VENTA EN LÍNEA
          </h3>
          <p data-id="element-272">
            ZUMPAGO es una empresa que mantiene Convenios con empresas de
            servicios públicos, empresas privadas, redes de recaudación,
            instituciones financieras que permite a través de sus canales
            realizar la recaudación de múltiples servicios de acuerdo con los
            convenios firmados.
          </p>
          <p data-id="element-273">
            Los usuarios debidamente registrados podrán comprar, adquirir o
            realizar pagos servicios de entidades públicas y/o privadas
            disponibles en las plataformas, para lo cual, deberán de seguir los
            procedimientos para ello habilitados, proporcionar los datos que le
            sean solicitados y en su caso realizar el pago correspondiente.
          </p>
          <p data-id="element-274">
            Una vez que el usuario finalice el proceso de pago podrá obtener un
            comprobante de pago y/o factura de conformidad con las formalidades
            exigidas por la respectiva legislación tributaria, dicho documento
            especificará el servicio adquirido o pago de servicios de empresas
            públicas o privadas adquiridos y/o contratados por el usuario.
          </p>
          <p data-id="element-275">
            De igual manera, ZUMPAGO podrá incluir un costo adicional por
            concepto de comisión de la recaudación de servicios públicos o
            privados, el cual deberá regirse a la normativa vigente aprobada de
            las entidades de control de cada país.
          </p>
          <p data-id="element-276">
            Es responsabilidad exclusiva de las Empresas Públicas o Privadas que
            prestan los diferentes servicios aplicar a los clientes los
            respectivos pagos a sus cuentas o en su defecto habilitar nuevos
            servicios contratados.
          </p>
          <p data-id="element-277">
            Toda actividad que se realice a través las plataformas podrá ser
            registrada y/o almacenada por ZUMPAGO exclusivamente para los
            siguientes fines:
          </p>
          <ul className="list-[lower-alpha] pl-6 space-y-3" data-id="element-278">
            <li data-id="element-279">
              Llevar un registro de las órdenes de pagos realizados mediante el
              sitio web para efectos de calidad en el servicio y atención al
              cliente.
            </li>
            <li data-id="element-280">
              Constituir un medio de prueba de las operaciones realizadas en el
              sitio web, para cualquier asunto legal de su competencia o
              interés.
            </li>
            <li data-id="element-281">
              Mejorar los servicios proporcionados a través del sitio web, entre
              otras cosas, para hacer más amigable la interfaz al usuario,
              facilitar la adquisición y/o contratación de los productos
              disponibles, así como para realizar recomendaciones al usuario con
              base en sus preferencias.
            </li>
          </ul>
          <p data-id="element-282">
            En todo caso se atenderán las disposiciones en materia de protección
            de datos personales, y cualquier duda o aclaración que se tenga con
            relación a este punto, o al ejercicio de los derechos establecidos a
            favor del usuario en materia de protección de datos personales,
            podrá ser consultada en nuestra política de privacidad.
          </p>

          <h3 className="text-xl font-bold text-gray-900 pt-2" data-id="element-283">
            4. FORMAS DE PAGO
          </h3>
          <p data-id="element-284">
            Los precios exhibidos en las plataformas son los finales e incluyen
            impuestos, y se presentarán en moneda de curso legal, salvo que, por
            exigencia legal, se señale y aplique cuestión distinta.
          </p>
          <p data-id="element-285">
            Los productos ofrecidos en este sitio, solo pueden ser pagados con:
          </p>
          <ul className="list-[lower-alpha] pl-6 space-y-3" data-id="element-286">
            <li data-id="element-287">
              Tarjetas de crédito Visa, Mastercard, Diners Club, American
              Express, Discovery siempre que mantengan un contrato vigente para
              tales efectos con ZUMPAGO.
            </li>
            <li data-id="element-288">
              Tarjetas de débito Electrón o Maestro que mantengan un contrato
              vigente para tales efectos con ZUMPAGO.
            </li>
            <li data-id="element-289">
              Los pagos serán realizados bajo la modalidad de consumo corriente
              o rotativo.
            </li>
            <li data-id="element-290">
              Los pagos bajo la modalidad consumo diferidos estarán sujetos a
              los convenios que ZUMPAGO firme con los Bancos Emisores o Redes
              Adquirentes de tarjetas de crédito.
            </li>
            <li data-id="element-291">
              En Chile, también se incluyen: Tarjeta de Crédito Hites, Tarjeta
              de Crédito ABCDin y Khipu.
            </li>
          </ul>
          <p data-id="element-292">
            Todo pago que se realice quedará sujeto a comprobación, por lo cual,
            se procederá a la generación de la orden de pago una vez que se
            compruebe que el cobro ha sido autorizado por parte de la
            institución financiera u operadora de pago.
          </p>
          <p data-id="element-293">
            ZUMPAGO no asume ninguna responsabilidad por los rechazos o negación
            en las autorizaciones de pago por parte de las entidades financieras
            o empresas operadoras de pagos.
          </p>
          <p data-id="element-294">
            El usuario consiente que, en su caso, se realicen cargos al momento
            de la solicitud de los productos o servicios, esto es, previo a la
            recepción de los bienes, productos o servicios que adquiera, compre
            o pague.
          </p>

          <h3 className="text-xl font-bold text-gray-900 pt-2" data-id="element-295">
            5. EXCLUYENTES DE RESPONSABILIDAD
          </h3>
          <p data-id="element-296">
            El usuario, libera a ZUMPAGO de cualquier responsabilidad en los
            siguientes casos:
          </p>
          <p data-id="element-297">
            Cuando se presente una falta en el cumplimiento de las obligaciones
            de ZUMPAGO y esta se genere por causas ajenas a la voluntad de
            ZUMPAGO, ya sea por caso fortuito o fuerza mayor, o bien, por el
            incumplimiento de un tercero del cual dependa ZUMPAGO para poder
            cumplir con las obligaciones a su cargo.
          </p>
          <p data-id="element-298">
            Cuando las faltas que se mencionan en el párrafo anterior generen un
            lucro cesante (en cualquier modalidad incluidos: pérdida de ingresos
            o de ahorros previstos, gastos adicionales, o incumplimiento en las
            obligaciones del usuario con terceras personas) o cualquier pérdida
            directa o indirecta que tenga el usuario, siempre que esta no fuera
            razonablemente previsible por las partes en el momento en el que se
            adquirieron, compraron o contrataron los productos adquiridos,
            ZUMPAGO no será responsable de dichas pérdidas.
          </p>

          <h3 className="text-xl font-bold text-gray-900 pt-2" data-id="element-299">6. VIGENCIA</h3>
          <p className="text-sm text-gray-500 pt-2 border-t border-gray-100" data-id="element-300">
            La vigencia de estas Condiciones Generales es desde el 28 de marzo
            de 2025 y permanecerá vigente hasta que exista una nueva versión que
            la reemplace.
          </p>
        </div>
      </div>
    </div>;
}